export function deleteProperties(obj: object, keysToDelete: string[]) {
  return Object.entries(obj)
    .filter(([key]) => !keysToDelete.includes(key))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}
